<template>
  <section id="reviews-section" test_id="reviews-section">
    <Card class="tw-space-y-6">
      <h2 class="tw-heading-2">Reviews ({{ count }})</h2>
      <TestimonialsCarousel v-if="testimonialVideos.length > 0" />
      <div class="tw-flex tw-flex-col tw-space-y-4">
        <Review
          v-for="review in reviews.data"
          :key="review.id"
          :review="review"
          :has-access-to-pin="
            hasObjectPermissions(
              $page.props.mentor,
              OBJECT_PERMISSIONS.MENTORS.OWNER,
            )
          "
          :is-pinned="
            hasObjectPermissions(review, OBJECT_PERMISSIONS.REVIEWS.FAVORITED)
          "
        />
        <InfiniteLoading @infinite="loadReviews">
          <template #spinner>
            <div class="tw-mx-auto tw-mt-4">
              <LoadingCircle class="tw-mx-auto" size="32" />
            </div>
          </template>
        </InfiniteLoading>
      </div>
    </Card>
  </section>
</template>

<script setup>
import Card from '@/shared/components/Card.vue'
import Review from './Review.vue'
import LoadingCircle from '@/shared/components/LoadingCircle.vue'
import { computed, inject } from 'vue'
import axios from 'axios'
import { usePage } from '@inertiajs/vue3'
import { usePermissionSystem } from '@/shared/composables/usePermissionSystem.js'
import { OBJECT_PERMISSIONS } from '@/shared/data/permissionSystem.js'
import TestimonialsCarousel from '@/modules/growthmentor/mentors/components/reviews/TestimonialsCarousel.vue'

const ITEMS_PER_PAGE = 15

defineProps({
  count: {
    type: Number,
    default: 0,
  },
})

const { hasObjectPermissions } = usePermissionSystem()
const page = usePage()

const reviews = inject('reviews')
const setReviews = inject('setReviews')
const testimonialVideos = computed(() => page.props.testimonialVideos)

const loadReviews = async ($state) => {
  try {
    const { data } = await axios.get(
      `/mentors/${page.props.mentor.id}/reviews`,
      {
        params: {
          offset: reviews.value.offset,
          size: ITEMS_PER_PAGE,
        },
      },
    )

    setReviews({
      total: data.total,
      offset: ITEMS_PER_PAGE,
      data: data.results,
    })

    if (data.results.length > 0) $state.loaded()
    const isDataLoaded = reviews.value.offset >= reviews.value.total
    if (isDataLoaded) $state.complete()
  } catch (error) {
    $state.error()
  }
}
</script>
